<DataGridView DataUrl="/Backend/Api/V2/Admin/Artikel/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="name" header="Name" />
  <DataGridViewColumn field="artnr" header="Art. Nr." />
  <DataGridViewColumn field="hilfsmittelnummer" header="Hilfsmittelnummer" />
  <DataGridViewColumn [isFixed]="true" [AllowOrder]="false" [AllowSearch]="false"> 
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Artikel">
        <ng-template #staticContent>
          <ArtikelEdit [Key]="row?.key"></ArtikelEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Artikel">
        <ng-template #staticContent>
          <ArtikelEdit></ArtikelEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
